import { render, staticRenderFns } from "./idbadgeIconSvg.vue?vue&type=template&id=8fef1766&"
import script from "./idbadgeIconSvg.vue?vue&type=script&lang=js&"
export * from "./idbadgeIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports